import React from 'react'
import { styled } from 'linaria/react'
import cx from 'classnames'
import t from 'prop-types'

const Container = styled.div`
  &.right {
    padding-left: theme('spacing.5');

    @screen sm {
      padding-left: calc(
        ((100vw - theme('screens.sm')) / 2) + theme('spacing.5')
      );
    }

    @screen md {
      padding-left: calc(
        ((100vw - theme('screens.md')) / 2) + theme('spacing.5')
      );
    }

    @screen lg {
      padding-left: calc(
        ((100vw - theme('screens.lg')) / 2) + theme('spacing.5')
      );
    }

    @screen xl {
      padding-left: calc(
        ((100vw - theme('screens.xl')) / 2) + theme('spacing.5')
      );
    }

    @screen page {
      padding-left: calc(
        ((theme('screens.page') - theme('screens.xl')) / 2) + theme('spacing.5')
      );
    }
  }

  &.left {
    padding-right: theme('spacing.5');

    @screen sm {
      padding-right: calc(
        ((100vw - theme('screens.sm')) / 2) + theme('spacing.5')
      );
    }

    @screen md {
      padding-right: calc(
        ((100vw - theme('screens.md')) / 2) + theme('spacing.5')
      );
    }

    @screen lg {
      padding-right: calc(
        ((100vw - theme('screens.lg')) / 2) + theme('spacing.5')
      );
    }

    @screen xl {
      padding-right: calc(
        ((100vw - theme('screens.xl')) / 2) + theme('spacing.5')
      );
    }

    @screen page {
      padding-right: calc(
        (theme('screens.page') - theme('screens.xl')) / 2 + theme('spacing.5')
      );
    }
  }
`

const Offset = ({ children, rounded, direction, inline, allowOverflow }) => {
  return (
    <Container
      className={cx('relative', {
        flex: inline,
        'justify-end right': direction === 'right',
        'justify-start left': direction === 'left',
      })}
    >
      <div
        className={cx(allowOverflow ? 'overflow-visible' : 'overflow-hidden', {
          'rounded-l-xl sm:rounded-l-2xl': rounded && direction === 'right',
          'rounded-r-xl sm:rounded-r-2xl': rounded && direction === 'left',
        })}
      >
        {children}
      </div>
    </Container>
  )
}

Offset.propTypes = {
  children: t.node.isRequired,
  direction: t.oneOf('left', 'right'),
  rounded: t.bool,
  inline: t.bool,
  allowOverflow: t.bool,
}

Offset.defaultProps = {
  direction: 'right',
  rounded: true,
  inline: false,
  allowOverflow: false,
}

export default Offset
